/*
 * @@Author: MuYang
 */
import Api from './api'
import response from '../../../utils/response'

// 获取模版
export async function requestTemplate (params) {
  const {type, url} = Api.queryTemplate
  const {content, isOk} = await response(
    {
      method: type,
      url,
      params,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    return content
  }
}

// 上传导入模版
export async function requestImport ({objectApiName, operationApiName, resourceUrl}, headerParams) {
  const {type, url} = Api.import
  const uri = `${url}/${objectApiName}/${operationApiName}`
  const params = { resourceUrl }
  const {content, isOk} = await response(
    {
      method: type,
      url: uri,
      params,
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  if (isOk) {
    return content
  }
}

// 导出
export async function requestExport ({objectApiName, operationApiName, options}, headerParams) {
  const {type, url} = Api.export
  const uri = `${url}/${objectApiName}/${operationApiName}`
  const {isOk} = await response(
    {
      method: type,
      url: uri,
      params: options,
      headerParams,
      option: {
        loadingOptions: false
      }
    }
  )
  return isOk
}
